<app-alert type="warning" [closeable]="false">
  {{ 'dashboard.query.exceedingpowerlimits.slow-warning' | translate }}
</app-alert>

<app-table
  #table
  [config]="tableConfig">
</app-table>
